<div class="auth-unavailable">
  <mat-icon class="auth-unavailable__icon" aria-hidden="true">cloud_off</mat-icon>

  <h1 class="auth-unavailable__title">
    {{ 'Auth.UnavailableTitle' | translate: locale.language }}
  </h1>

  <p class="auth-unavailable__message">
    {{ 'Auth.UnavailableMessage' | translate: locale.language }}
  </p>

  <button mat-flat-button color="primary" type="button" (click)="retry()">
    {{ 'Try Again' | translate: locale.language }}
  </button>
</div>
